<div class="estilo-mensaje">
  <p class="titulo">{{ data.titulo }}</p>

  <div class="contenido-centrado">
    <img *ngIf="data.tipo == 'warning'" src="assets/Img/warning-mensaje.png" alt="" width="80">
    <img *ngIf="data.tipo == 'ok'" src="assets/Img/check-mensaje.png" alt="" width="80">

    <p class="items-cuerpo" [innerHTML]="data.message"></p>

    <div class="button-container mt-3">
      <button *ngIf="data.pregunta" pButton pRipple type="button" class="p-button-primary" (click)="onAccept()"
        [label]="getTextoOpcion1()">
      </button>
      <button *ngIf="data.pregunta" pButton pRipple type="button" class="p-button-secondary" (click)="onReject()"
        [label]="getTextoOpcion2()">
      </button>
      <button *ngIf="!data.pregunta" pButton pRipple type="button" class="p-button-primary" (click)="onClose()"
        label="Aceptar">
      </button>
    </div>

    <div *ngIf="information" (click)="view()" class="view cursor-pointer mt-3 text-primary">
      Ver detalle
    </div>

    <div class="information mt-2" *ngIf="viewDetail">
      <p-scrollPanel [style]="{ width: '100%', height: '100px' }" styleClass="custombar2">
        <p class="detalle">
          {{ data.detalle }}
        </p>
      </p-scrollPanel>
    </div>
  </div>
</div>